import React from 'react';
import { useThemeContext } from './ThemeProvider';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function ThemedLayout({ children, className = '' }: Props) {
  const { theme } = useThemeContext();

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    width: '100%',
    color: theme.textColor || '#ffffff',
    fontFamily: theme.fontFamily || 'IntroRust',
    position: 'relative',
    overflow: 'hidden'
  };

  const backgroundStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundImage: theme.backgroundImage ? `url(${theme.backgroundImage})` : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    zIndex: 0,
    transform: 'translate3d(0,0,0)', // Force hardware acceleration
    WebkitBackfaceVisibility: 'hidden',
    backfaceVisibility: 'hidden'
  };

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.backgroundColor || 'rgba(0, 0, 0, 0.75)',
    zIndex: 1,
    transition: 'background-color 0.3s ease-in-out'
  };

  const contentStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 2,
    minHeight: '100vh',
    width: '100%'
  };

  return (
    <div style={containerStyle}>
      <div style={backgroundStyle} />
      <div style={overlayStyle} />
      <div style={contentStyle} className={className}>
        {children}
      </div>
    </div>
  );
}